// TRUE: VALIDA EL TOKEN EN EL KEYCLOAK

export const API_URL = process.env.REACT_APP_API_URL;

export const parameters = {
  cipherKey: '4756112463587241',
  cipherIV: '1112131415161718',
  keyAPILocations:
    'eyJzdWIiOiJKYXJkaW5BenVheW8iLCJuYW1lIjoiSkFQQUdPUyIsImlhdCI6MTUxNjIzOTAyMn0',
  tamanioClave: 4
}

export const TIPO_INPUT = 'outlined'

export const estadosTable = [{id: 1, descripcion: 'ACTIVO'},
  {id: 2, descripcion: 'TEMPORAL'}, {id: 9, descripcion: 'ANULADO'}]

export const CONSUMIDOR_FINAL = "9999999999999";
export const ID_EMPRESA = 1;
